import { Injectable } from '@angular/core';
import { Observable ,  of } from 'rxjs';
import { StorageService } from '../../storageprovider';


@Injectable()
export class SearchHistoryService {
    historyLength = 5;
    constructor(private _storage:StorageService) { }

    getSearchHistoryFromLocalStorage() {
        const strHistroy = this._storage.GetItem('search');
        const history = strHistroy ? JSON.parse(strHistroy) : [];
        return history;
    }

    getAll() {
        return of(this.getSearchHistoryFromLocalStorage());
    }

    push(keyword) {
        let history = this.getSearchHistoryFromLocalStorage();

        const keywordExists = history.some(function(el) { return el.title === keyword; });

        history = history.filter(item => item.title !== keyword);

        history.unshift({title: keyword});

        history = history.slice(0, this.historyLength);

        this._storage.SetItem('search', JSON.stringify(history));

        return history;
    }

    clear() {
        this._storage.RemoveItem('search');
        return [];
    }
}
